import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

/** Status colour mapping — single source of truth, design.md §7.3. */
const badgeVariants = cva('inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium', {
  variants: {
    variant: {
      active: 'bg-ata-green/15 text-ata-green',
      pending: 'bg-ata-gold/15 text-ata-gold-text',
      expired: 'border border-ata-orange bg-transparent text-ata-orange',
      revoked: 'bg-ata-red/15 text-ata-red',
      expiring: 'bg-ata-orange/15 text-ata-orange',
      neutral: 'bg-muted text-muted-foreground',
      get: 'bg-ata-green/15 text-ata-green',
      post: 'bg-ata-light-blue/15 text-ata-light-blue',
      patch: 'bg-ata-orange/15 text-ata-orange',
      delete: 'bg-ata-red/15 text-ata-red',
    },
  },
  defaultVariants: { variant: 'neutral' },
})

export function Badge({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />
}

export function StatusBadge({ status }: { status: 'pending' | 'active' | 'revoked' }) {
  const label = { pending: 'Pending', active: 'Active', revoked: 'Revoked' }[status]
  return <Badge variant={status}>{label}</Badge>
}
